export default function AttachAgendaItemReportFolderDirective() {
  return {
    template: require('./attach-agendaItem-report-folder.html'),
    scope: {
      agendaItemId: '=',
      serviceId: '=',
      reportFolder: '=',
    },
    controller: 'AttachAgendaItemReportFolderController',
    controllerAs: 'attachAgendaItemReportFolderVM',
    bindToController: true,
    replace: true
  };
}
